import { useState } from 'react';
import '../../login/components/MainSection.scss';
import { useNavigate } from 'react-router-dom';
import Logo from '../../../../components/Atoms/Logo.jsx';

export default function MainSection(props) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [ripple, setRipple] = useState(null);

  const handleSignup = async () => {
    const name = document.querySelector('#txtName')?.value;
    const email = document.querySelector('#txtEmail')?.value;
    const password = document.querySelector('#txtPassword')?.value;
    const confirmPassword = document.querySelector('#txtConfirmPassword')?.value;

    if (!name || !email || !password || !confirmPassword) {
      props.handlers.onSignupError("Please fill in all fields.");
      return;
    }

    if (password !== confirmPassword) {
      props.handlers.onSignupError("Passwords do not match.");
      return;
    }

    if (password.length < 6) {
      props.handlers.onSignupError("Password must be at least 6 characters long.");
      return;
    }

    setIsLoading(true);
    try {
      await props.handlers.onSignup({ name, email, password });
    } finally {
      setIsLoading(false);
    }
  };

  const handleButtonClick = async (e) => {
    if (isLoading) return;
    if (e?.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      setRipple({ x: e.clientX - rect.left, y: e.clientY - rect.top });
      setTimeout(() => setRipple(null), 600);
    }
    await handleSignup();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") handleSignup();
  };

  const handleLoginRedirect = (e) => {
    e.preventDefault();
    navigate('/Login');
  };

  return (
    <div className="login-box">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <Logo size={34} />
          </div>
          <h2 className="login-title">Create Account</h2>
          <p className="login-description">Join LabelFlow and start building vision AI models</p>
        </div>

        <form className="login-form" onSubmit={(e) => e.preventDefault()}>
          <div className="form-group form-group--1">
            <label className="form-label" htmlFor="txtName">Full Name</label>
            <div className="input-wrapper">
              <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <input type="text" className="form-input" id="txtName" placeholder="John Doe" autoComplete="name" />
            </div>
          </div>

          <div className="form-group form-group--2">
            <label className="form-label" htmlFor="txtEmail">Email Address</label>
            <div className="input-wrapper">
              <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              <input type="email" className="form-input" id="txtEmail" placeholder="you@example.com" autoComplete="email" />
            </div>
          </div>

          <div className="form-group form-group--3">
            <label className="form-label" htmlFor="txtPassword">Password</label>
            <div className="input-wrapper">
              <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              <input type="password" className="form-input" id="txtPassword" placeholder="Enter your password" onKeyDown={handleKeyDown} autoComplete="new-password" />
            </div>
          </div>

          <div className="form-group form-group--4">
            <label className="form-label" htmlFor="txtConfirmPassword">Confirm Password</label>
            <div className="input-wrapper">
              <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              <input type="password" className="form-input" id="txtConfirmPassword" placeholder="Confirm your password" onKeyDown={handleKeyDown} autoComplete="new-password" />
            </div>
          </div>

          <div className="form-group form-group--5">
            <button type="button" onClick={(e) => handleButtonClick(e)} className={`login-button ${isLoading ? 'login-button--loading' : ''}`} disabled={isLoading}>
              {ripple && <span className="login-button__ripple" style={{ left: ripple.x, top: ripple.y }} aria-hidden />}
              {isLoading ? (
                <span className="login-button__spinner" />
              ) : (
                <>
                  <span>Sign Up</span>
                  <svg className="button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </>
              )}
            </button>
          </div>
        </form>

        <div className="login-footer">
          <p className="footer-text">
            Already have an account?{' '}
            <a href="#" onClick={handleLoginRedirect} className="footer-link">Sign In</a>
          </p>
        </div>
      </div>
    </div>
  );
}

